<template>
  <div class="container_DefaultLayout">
    <div class="menu_DefaultLayout">
      <sidebar></sidebar>
    </div>

    <div class="contentHead_DefaultLayout">
      <top-navbar></top-navbar>
      <div class="content_DefaultLayout">
        <layout-content></layout-content>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "./Sidebar.vue";
import TopNavbar from "./TopNavbar.vue";

import LayoutContent from "./LayoutContent.vue";

@Component({
  name: "default-layout",
  components: {
    Sidebar,
    TopNavbar,
    LayoutContent,
  },
})
export class DefaultLayout extends Vue {
  constructor() {
    super();
  }
}
export default DefaultLayout;
</script>

<style lang="scss" scoped>
.container_DefaultLayout {
  display: flex;
  min-height: 100vh;
}
.menu_DefaultLayout {
  background-color: #4c4c4c;
}
.contentHead_DefaultLayout {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content_DefaultLayout {
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 64px);
}
</style>
